import React from 'react';
import './Nutri.css';

const teamMembers = [
  {
    name: '🌿 Calories = Energy',
    description: 'They fuel every function in your body—from breathing to thinking to movement.' 
 },
  {
    name: '🌿 Balance is key',
    description: 'Energy intake should match energy expenditure to maintain a healthy weight.' 
 },
   {
    name: '🌿 Quality matters',
    description: 'Not all calories are equal. 100 kcal from leafy greens nourishes differently than 100 kcal from soda.' 
 },
 
  {
    name: '🌿 Not precision, but orientation:',
    description: 'Nutrient tables don’t offer exact truths—they offer direction. Like a compass, they point toward balance, not dictate it. The same nutrient behaves differently depending on gut flora, emotional state, time of day, and even ancestral memory..' 
 },
  {
    name: '🌿 Trace/Measured in',
    description: 'Energy is measured in kilocalories (kcal), representing the total heat released from food. Micronutrients are traced in micrograms (µg) or milligrams (mg), depending on their concentration and biological significance.' 
 },
   {
    name: '🌿 Explore',
    description: 'All nutritional values whether calories or micronutrients are approximations, not absolutes. For precise guidance, one should always consult a physician, nutritionist, or relevant expert. Lorevial is not a diagnostic tool, but a vessel for exploring the wisdom of ingredients and nutrients inviting reflection, discovery, and deeper connection to what nourishes us.' 
 },
];

const NeutriFacts = () => {
  return (
    <div className="about-container">
      <div className="header">
     
        <h1>Key Facts</h1>
      
      </div>
      <div className="card-grid">
        {teamMembers.map((member, index) => (
          <div className="card" key={index}>
            {member.image && <img src={member.image} alt={member.name} />}
            <h2>{member.name}</h2>
            {member.role && <h4>{member.role}</h4>}
            <p>{member.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NeutriFacts;
